import { ReactComponent as ChevronLeftIcon } from "assets/icons/chevron-left.svg";
import { ReactComponent as ChevronRightIcon } from "assets/icons/chevron-right.svg";
import getMonth from "date-fns/getMonth";
import getYear from "date-fns/getYear";
import add from "date-fns/add";

const MONTHS = [
    { label: "Siječanj", value: 0 },
    { label: "Veljača", value: 1 },
    { label: "Ožujak", value: 2 },
    { label: "Travanj", value: 3 },
    { label: "Svibanj", value: 4 },
    { label: "Lipanj", value: 5 },
    { label: "Srpanj", value: 6 },
    { label: "Kolovoz", value: 7 },
    { label: "Rujan", value: 8 },
    { label: "Listopad", value: 9 },
    { label: "Studeni", value: 10 },
    { label: "Prosinac", value: 11 },
];

const findMonth = (val: number) => MONTHS.find(m => m.value === val);

export function Navbar(props: any) {
    const currentDate = `${findMonth(getMonth(props.month))?.label} ${getYear(props.month)}`;

    return (
        <div className={`${props.className}`}>
            <ChevronLeftIcon
                className="day-picker-control"
                onClick={() => props.onPreviousClick()}
            />
            <div>
                <span className="day-picker-month">{currentDate}</span>
            </div>
            <ChevronRightIcon className="day-picker-control" onClick={() => props.onNextClick()} />
        </div>
    );
}
